import { ApiServiceV1 } from '@services/api.service';

export const PackageReturnsApiService = {
  async getPackageReturns({
    trackingNumber = null, productReshipable = null, resendToCustomer = null,
    suffix, pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/return`, {
      params: {
        productReshipable: productReshipable || null,
        resendToCustomer: resendToCustomer || null,
        trackingNumber,
        pageNum,
        pageSize,
      },
    });

    return data || [];
  },

  async getPackageReturn({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/return/${id}`);

    return data || {};
  },

  async generateShippingLabel({ suffix, format, trackingNumber }) {
    const { data } = await ApiServiceV1.post(
      `${suffix}/return/${trackingNumber}/label/shipping`,
      null,
      {
        params: {
          format,
        },
      },
    );

    return data || {};
  },
};
